/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bakery_Home_Hero_TitleInputs */

const en_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Bakery`)
};

const ar_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخبز الغابة`)
};

const de_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waldbäckerei`)
};

const es_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastelería del Bosque`)
};

const fr_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boulangerie de la Forêt`)
};

const it_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasticceria della Foresta`)
};

const ja_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森のベーカリー`)
};

const ko_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숲 베이커리`)
};

const pt_br_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padaria da Floresta`)
};

const ru_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лесная пекарня`)
};

const th_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบเกอรีแห่งป่า`)
};

const tr_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orman Fırını`)
};

const zh_cn_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森林烘焙坊`)
};

const zh_tw_bakery_home_hero_title = /** @type {(inputs: Bakery_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森林烘焙坊`)
};

/**
* | output |
* | --- |
* | "Forest Bakery" |
*
* @param {Bakery_Home_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const bakery_home_hero_title = /** @type {((inputs?: Bakery_Home_Hero_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Home_Hero_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_home_hero_title(inputs)
	if (locale === "ar") return ar_bakery_home_hero_title(inputs)
	if (locale === "de") return de_bakery_home_hero_title(inputs)
	if (locale === "es") return es_bakery_home_hero_title(inputs)
	if (locale === "fr") return fr_bakery_home_hero_title(inputs)
	if (locale === "it") return it_bakery_home_hero_title(inputs)
	if (locale === "ja") return ja_bakery_home_hero_title(inputs)
	if (locale === "ko") return ko_bakery_home_hero_title(inputs)
	if (locale === "pt_br") return pt_br_bakery_home_hero_title(inputs)
	if (locale === "ru") return ru_bakery_home_hero_title(inputs)
	if (locale === "th") return th_bakery_home_hero_title(inputs)
	if (locale === "tr") return tr_bakery_home_hero_title(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_home_hero_title(inputs)
	return zh_tw_bakery_home_hero_title(inputs)
});